import React, { useContext } from "react";
import { ProductContext } from "../../context";
import { CssLeft, CssOrderNum, CssActions } from "./UserAccount";
import { orders } from "./orders";
import styled, { css } from "styled-components";
import {
  CssImage,
  CSSproductDesc,
  CssPrice,
  CssPaper,
  CssPopSection,
  CssFormGroup,
  Button,
  CssContentBlock,
} from "./../uikit-b2c/uikit-b2c";
import { Paper } from "../uikit-b2c/uikit-b2c";
import { CssCols } from "./UserAccountRefunds";

export const Orders = ({ collapsed, limit, filter, type }) => {
  return (
    <div style={{ width: "100%" }}>
      {orders["orders"].map((oneOrder, ind) => {
        if (
          (typeof limit === "undefined" || (!!limit && ind < limit)) &&
          ((oneOrder && oneOrder["purchase"]["virtual_item"]) ||
            oneOrder["purchase"]["virtual_currency"])
        ) {
          return (
            <OrderLine
              collapsed={collapsed}
              key={`order_${oneOrder["operation_id"]}`}
              purchase={oneOrder["purchase"]}
              filter={filter}
              type={type}
              // operation_id={oneOrder['operation_id']}
              // date={oneOrder['date']}
            />
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export const OrderLine = ({
  collapsed,
  filter = false,
  purchase,
  operation_id = 95806539,
  date = "2017-07-10 23:10",

  type = "order",
}) => {
  let virtual_item = purchase["virtual_item"];
  let virtual_currency = purchase["virtual_currency"];
  let subscription = purchase["subscription"];
  const valueFromContext = useContext(ProductContext);
  if (
    (!filter && (virtual_item || virtual_currency)) ||
    (filter === "subscription" && subscription)
  ) {
    return (
      <CssFormGroup indentation="lg">
        <Paper indentation="lg">
          <CssFormGroup indentation="md">
            <CssCols
              style={{ width: "100%" }}
              // theme={valueFromContext.getTheme()}
            >
              {type === "order" && (
                <CssLeft theme={valueFromContext.getTheme()}>
                  <CssOrderNum>
                    <CssFormGroup indentation="xs">
                      Order ID: {operation_id}
                      <br />
                      {date}
                    </CssFormGroup>
                  </CssOrderNum>
                </CssLeft>
              )}

              <OrderRight>
                {virtual_item &&
                  filter !== "subscription" &&
                  virtual_item.map((oneOrd, index) => {
                    return (
                      <Order
                        collapsed={collapsed}
                        type="vi"
                        key={`oneorder_${index}`}
                        image_url={oneOrd["image"]}
                        sku={oneOrd["sku"]}
                        name={oneOrd["name"]}
                        description={oneOrd["description"]}
                        quantity={oneOrd["quantity"]}
                      />
                    );
                  })}
                {virtual_currency &&
                  filter !== "subscription" &&
                  virtual_currency.map((oneOrd, index) => {
                    return (
                      <Order
                        collapsed={collapsed}
                        key={`oneorder_${index}`}
                        type="vc"
                        name={oneOrd["name"]}
                      />
                    );
                  })}
                {subscription &&
                  filter === "subscription" &&
                  subscription.map((oneOrd, index) => {
                    return (
                      <Order
                        collapsed={collapsed}
                        key={`oneorder_${index}`}
                        type="subs"
                        icon="https://res.cloudinary.com/maiik/image/upload/v1567205189/Xsolla_Store_icons/ic_coins_subs.svg"
                        name="Subscription"
                        description="Redeem coupon"
                      />
                    );
                  })}
              </OrderRight>
            </CssCols>
          </CssFormGroup>

          {type === "order" && (
            <CssActions
              theme={valueFromContext.getTheme()}
              style={{ width: "100%" }}
            >
              <CssCols theme={valueFromContext.getTheme()}>
                <CssLeft>
                  <Button
                    size="sm"
                    appearance="flatten"
                    color="colorText"
                    theme={valueFromContext.getTheme()}
                  >
                    Details
                  </Button>
                </CssLeft>
                <OrderRight>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      size="sm"
                      appearance="flatten"
                      color="colorText"
                      theme={valueFromContext.getTheme()}
                    >
                      Request refund
                    </Button>
                  </div>
                </OrderRight>
              </CssCols>
            </CssActions>
          )}
        </Paper>
      </CssFormGroup>
    );
  } else {
    return null;
  }
};

export const Order = ({
  collapsed,
  image_url = "http://cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
  name = "Product Name",
  description = "Conquer your foes with vindication using the Basic Blaster!",
  price = "$2.99",
  quantity,
  children,
  type = "virtual_item",
  style,
}) => {
  const valueFromContext = useContext(ProductContext);
  return (
    <div style={{ width: collapsed ? "auto" : "100%" }}>
      <CssCols
        style={{ width: "100%" }}
        cols={collapsed ? "1fr" : "minmax(44px, auto) 4fr 1fr 1fr"}
      >
        {type === "virtual_item" && (
          <CssImage
            style={{
              color: valueFromContext.getTheme("colorActive"),
              width: 64,
              height: 64,
              backgroundImage: `url(${image_url})`,
            }}
          />
        )}

        {type === "game" && (
          <CssImage
            style={{
              color: valueFromContext.getTheme("colorActive"),
              width: 64,
              height: 64,
              backgroundImage: `url(${image_url})`,
              backgroundSize: "cover",
            }}
          />
        )}

        {type === "virtual_currency" && (
          <CssImage
            style={{
              color: valueFromContext.getTheme("colorActive"),
              width: 60,
              height: 60,
            }}
          >
            <svg
              width={40}
              height={40}
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                fill="currentColor"
                fillOpacity="0.5"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 34.1667C27.824 34.1667 34.1667 27.824 34.1667 20C34.1667 12.176 27.824 5.83333 20 5.83333C12.176 5.83333 5.83333 12.176 5.83333 20C5.83333 27.824 12.176 34.1667 20 34.1667ZM20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                fill="currentColor"
              />
              <path
                d="M21.966 22.7822C21.966 22.2831 21.7897 21.8626 21.437 21.5208C21.0898 21.179 20.5011 20.8698 19.6711 20.5931C18.5155 20.2405 17.6718 19.782 17.1401 19.2178C16.6139 18.6481 16.3507 17.9265 16.3507 17.0531C16.3507 16.1633 16.6085 15.4336 17.1239 14.8639C17.6447 14.2943 18.3581 13.9552 19.2642 13.8467V12.0645H20.4767V13.8548C21.3882 13.9796 22.0962 14.3621 22.6007 15.0023C23.1107 15.6425 23.3657 16.5187 23.3657 17.6309H21.8683C21.8683 16.8659 21.6866 16.2582 21.3231 15.8079C20.9596 15.3576 20.4686 15.1325 19.8501 15.1325C19.2045 15.1325 18.7108 15.3007 18.369 15.637C18.0272 15.968 17.8563 16.4319 17.8563 17.0286C17.8563 17.582 18.0353 18.0242 18.3934 18.3551C18.7569 18.6807 19.351 18.9791 20.1756 19.2503C21.0057 19.5162 21.6513 19.8118 22.1125 20.1374C22.579 20.4575 22.9208 20.8318 23.1379 21.2604C23.3603 21.689 23.4715 22.1909 23.4715 22.766C23.4715 23.6828 23.1948 24.4207 22.6414 24.9795C22.0935 25.5383 21.3231 25.8692 20.3302 25.9723V27.5267H19.1258V25.9723C18.1167 25.8801 17.3246 25.522 16.7495 24.8981C16.1799 24.2688 15.895 23.417 15.895 22.3428H17.4006C17.4006 23.0969 17.5986 23.6774 17.9946 24.0843C18.3907 24.4912 18.9522 24.6947 19.6792 24.6947C20.3899 24.6947 20.9487 24.5238 21.3556 24.182C21.7625 23.8402 21.966 23.3736 21.966 22.7822Z"
                fill="currentColor"
              />
            </svg>
          </CssImage>
        )}

        {type === "subscription" && (
          <CssImage
            style={{
              color: valueFromContext.getTheme("colorActive"),
              width: 60,
              height: 60,
            }}
          >
            <svg
              width={60}
              height={60}
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.375 5H20C28.2843 5 35 11.7157 35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 15.858 6.67962 12.1072 9.3934 9.3934L9.83534 8.95146L20.4419 19.5581C20.686 19.8021 20.686 20.1979 20.4419 20.4419C20.1979 20.686 19.8021 20.686 19.5581 20.4419L9.84532 10.7292C7.61157 13.1744 6.25 16.4277 6.25 20C6.25 27.5939 12.4061 33.75 20 33.75C27.5939 33.75 33.75 27.5939 33.75 20C33.75 12.6155 27.9288 6.5907 20.625 6.26395V9.375C20.625 9.72018 20.3452 10 20 10C19.6548 10 19.375 9.72018 19.375 9.375V5Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                fill="currentColor"
                fillOpacity="0.5"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.75473 19.6854C9.8297 17.1975 10.7912 14.9325 12.3342 13.1955L11.6163 12.498C9.83435 14.4881 8.75059 17.1162 8.75 19.9975V19.9979C8.75 20.1705 8.88991 20.3104 9.0625 20.3104H9.75461L9.75473 19.6854ZM29.0624 19.9979C29.0624 19.8253 29.2024 19.6854 29.3749 19.6854H30.9374C31.11 19.6854 31.2499 19.8253 31.2499 19.9979C31.2499 20.1705 31.11 20.3104 30.9374 20.3104H29.3749C29.2024 20.3104 29.0624 20.1705 29.0624 19.9979ZM19.6874 30.9374C19.6874 31.11 19.8273 31.2499 19.9999 31.2499C20.1725 31.2499 20.3124 31.11 20.3124 30.9374V29.3749C20.3124 29.2023 20.1725 29.0624 19.9999 29.0624C19.8273 29.0624 19.6874 29.2023 19.6874 29.3749V30.9374Z"
                fill="currentColor"
                fillOpacity="0.5"
              />
            </svg>
          </CssImage>
        )}

        {!collapsed && (
          <CssFormGroup>
            <CssFormGroup indentation="xs">
              <CSSproductH>{name}</CSSproductH>
            </CssFormGroup>
            <CSSproductDesc
              indentation="xs"
              style={{ opacity: 0.6, fontSize: "0.9em" }}
            >
              {description}
            </CSSproductDesc>
          </CssFormGroup>
        )}

        {/* {!!quantity && quantity > 1 &&  */}
        {!collapsed && <CssFormGroup indentation="xs">{quantity}</CssFormGroup>}
        {/* } */}

        {!collapsed && (
          <CssPrice theme={valueFromContext.getTheme()}>{price}</CssPrice>
        )}
      </CssCols>
      {children}
    </div>
  );
};

export const CSSproductH = styled.div`
  font-weight: 500;
  font-size: 1.2em;
`;

export const OrderRight = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;
